module.exports = __webpack_public_path__ + "static/microsoft-partner-4901e028bd5336c68bc4b0b5602d9bb3.png";